import { FC } from 'react';

import { IconNames } from './Icon.types';
import sprite from './icons.svg';

export type IconProps = {
  name: IconNames;
  className?: string;
  testID?: string;
  size?: number;
  width?: number;
  height?: number;
  onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
  src?: string;
};

export const Icon: FC<IconProps> = (props) => {
  const {
    name,
    className,
    testID,
    size = 48,
    width,
    height,
    onClick,
    src = sprite,
  } = props;

  return (
    <svg
      onClick={onClick}
      role="presentation"
      aria-hidden="true"
      focusable="false"
      className={className}
      data-testid={testID}
      viewBox={`0 0 ${width || size} ${height || size}`}
      {...{
        width: width || size,
        height: height || size,
      }}
    >
      <use href={`${src}#${name}`} />
    </svg>
  );
};
